<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">{{$t("Thank you for your purchase! In case of any questions, please contact us at support@")}}{{ $parent.hostname }}</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'PaymentSuccessPage',
  props: [],
  components: {
  },
  data: function() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>